import styled from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import { ChevronRight } from '@magalu/stereo-ui-icons';
import Flex from '../Flex';
export const SellerItem = styled(Flex)`
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  padding: ${props => themeGet('space.2')(props)}px 0;
`;
export const SellerText = styled.span`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  color: ${props => getTextColor('light')(props)};
`;
export const SellerName = styled.span`
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  color: ${props => getTextColor('base')(props)};
`;
export const ListItem = styled(Flex)`
  align-items: center;
  height: 100%;
`;
export const ChevronRightIcon = styled(ChevronRight).attrs(props => ({
  color: getTextColor('lighter')(props)
}))``;
export const Link = styled.a`
  text-decoration: none;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('lighter')(props)};
`;
export const Text = styled.span`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('scratched')(props)};
`;
export const Name = styled.span`
  display: flex;
`;